import Typography from "@material-ui/core/esm/Typography";
import React from 'react';
export default function Subtitle({
  className,
  children,
  align,
  id,
  component = 'subtitle1'
}) {
  return /*#__PURE__*/React.createElement(Typography, {
    className: className,
    align: align,
    variant: "subtitle1",
    component: component,
    id: id
  }, children);
}
Subtitle.defaultProps = {
  align: 'left',
  className: '',
  component: 'subtitle1'
};